<template>
    <div class="listContainer">
        <div class="security-tip">插件无病毒木马，可能会被杀毒软件误报，请先退出杀毒软件放心下载安装</div>
        <div v-if="platforms.results && platforms.results.length > 0">
            <div v-for="platform in platforms.results" :key="platform.id" class="platform-table-section">
                <h3 class="platform-title">For {{ platform.name }}</h3>               
                
                <table class="software-table">
                    <thead>
                        <tr>
                            <th>文件</th>
                            <th>版本</th>
                            <th>运行平台</th>
                            <th>发布日期</th>
                            <th>下载</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="plugin in getPluginsByPlatform(platform.id)" :key="plugin.id">
                            <td>{{ plugin.name }}</td>
                            <td>{{ plugin.version }}</td>
                            <td>{{ platform.name }}&nbsp;{{ plugin.platform_version }}</td>
                            <td>{{ formatDate(plugin.publish_date) }}</td>
                            <td>
                                <div class="download-section">
                                    <a 
                                        v-if="plugin.file" 
                                        :href="getDownloadUrl(plugin)"
                                        target="_blank"
                                        class="download-link"
                                        @click="handleDownload(plugin)"
                                    >
                                        下载
                                    </a>
                                    <span v-else class="no-download">等待发布</span>
                                </div>
                            </td>
                        </tr>
                        <tr v-if="getPluginsByPlatform(platform.id).length === 0">
                            <td colspan="5" class="no-plugins">暂无插件</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
        
        <div v-else class="loading">
            {{ loading ? '加载中...' : '暂无数据' }}
        </div>
    </div>
</template>

<script>
import axios from 'axios';

export default {
    name: 'PluginsList',     
    data: function() {
        return {
            platforms: { results: [] },
            plugins: { results: [] },
            loading: true
        }
    }, 
    mounted() {
        this.getPlatforms();
        this.getPlugins();
    },
    methods: {
        handleDownload(plugin) {
            window.open(this.getDownloadUrl(plugin), '_blank');
            event.preventDefault();
        },

        getDownloadUrl(plugin) {            
            if (!plugin || !plugin.file) return '#';            
            let fileUrl = plugin.file;
            if (fileUrl.startsWith('/')) {
                fileUrl = `/api/plugins/plugins/${plugin.id}/download/`;
            }
            
            return fileUrl;
        },

        getFileName(plugin) {
            if (!plugin || !plugin.file) return 'unknown.file';
            let fileName = plugin.file.split('/').pop();
            if (!fileName.includes('.')) {
                fileName = `${plugin.name}_v${plugin.version}.zip`;
            }
            return fileName;
        },

        formatDate(dateString) {
            if (!dateString) return '';
            try {
                const date = new Date(dateString);
                return date.toLocaleDateString('zh-CN');
            } catch {
                return dateString;
            }
        },

        getPlatforms() {
            this.loading = true;
            axios.get('/api/plugins/platform/')
                .then(response => {
                    this.platforms = response.data;
                })
                .catch(error => {
                    console.error('获取平台数据失败:', error);
                })
                .finally(() => {
                    this.loading = false;
                });
        },
        
        getPlugins() {
            axios.get('/api/plugins/plugins/')
                .then(response => {
                    this.plugins = response.data;
                })
                .catch(error => {
                    console.error('获取插件数据失败:', error);
                });
        },
        
        getPluginsByPlatform(platformId) {
            if (!this.plugins.results || !Array.isArray(this.plugins.results)) {
                return [];
            }
            return this.plugins.results.filter(plugin => plugin && plugin.platform === platformId);
        }
    }
}
</script>

<style scoped>
.listContainer {
    padding: 20px;
    width: fit-content;
    margin: 0 auto;
}

.platform-table-section {
    margin-bottom: 40px;
}

.platform-title {
    color: #45B5B5;
    padding: 8px;
}

.software-table {
    width: auto;
    border-collapse: collapse;
    border-radius: 8px;
}

.software-table tbody tr:nth-child(odd) {
    background-color: #ffffff;
}

.software-table tbody tr:nth-child(even) {
    background-color: rgb(250, 250, 250);
}

.software-table thead {
    background-color: rgb(240, 240, 240);
}

.software-table th {
    padding: 12px 16px;
    color: #666;
    text-align: center;
    font-weight: 600;
}

.software-table td {
    padding: 12px 24px;
    border-bottom: 1px solid #e9ecef;
    text-align: center;
    font-size: 14px;
    color: #555;
}

.download-section {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 8px;
}

.security-tip {
    margin: 24px auto;
    font-size: 18px;
    font-weight: bold;
    color: #45B5B5;
    letter-spacing: 2px;
}

.download-link {
    padding: 4px 16px;
    background-color: #45B5B5;
    color: white;
    border: none;
    border-radius: 4px;
    cursor: pointer;
    font-size: 14px;
    text-decoration: none;
    transition: all 0.3s ease;
}

.download-link:hover {
    background-color: #3a9c9c;
    text-decoration: none;
    color: white;
}

.no-download {
    color: #999;
    font-style: italic;
}

.no-plugins {
    text-align: center;
    color: #6c757d;
    font-style: italic;
    padding: 20px;
}

.loading {
    text-align: center;
    padding: 50px;
    color: #6c757d;
    font-size: 1.1em;
}

@media (max-width: 768px) {
    .software-table {
        font-size: 0.9em;
    }
    
    .software-table th,
    .software-table td {
        padding: 8px 12px;
    }
}
</style>